import { useChapterHistoryManagementController } from './ChapterHistoryManagementController';
import PrivatePageLayout from '../../../layout/privatePageLayout/PrivatePageLayout';
import styles from './ChapterHistoryManagement.module.scss';
import DropDown from '../../../components/stateless/dropDown/DropDown';
import { Loader } from '@progress/kendo-react-indicators';
import { useEffect } from 'react';
import ChapterHistoryTable from './components/chapterHistoryTable/ChapterHistoryTable';
import ChapterHistoryForm from './components/chapterHistoryForm/ChapterHistoryForm';

function ChapterHistoryManagement() {
    const {
        // Functions
        handleAgencySelectChange,
        handleTitleSelectChange,
        handleChapterSelectChange,
        reloadChapterHistory,

        // Redux
        getAllAgencies,

        // State
        agencies,
        agencyTitles,
        titleChapters,
        chapterHistory,
        selectedAgency,
        selectedTitle,
        selectedChapter,
        titlesAreLoading,
        chaptersAreLoading,
        chapterHistoryIsLoading,
        dispatch
    } = useChapterHistoryManagementController();

    useEffect(() => {
        if (agencies.length < 1) {
          dispatch(getAllAgencies());
        }
      }, [dispatch, agencies, getAllAgencies])

    const renderChapterHistoryManagement = () => {
        return (
            <div>
                <div className={styles.wrapper}>
                <h3><b>Chapter Select</b></h3>
                    <div>
                        <DropDown
                            size="medium"
                            label="Agency"
                            value={selectedAgency}
                            listItems={agencies}
                            onSelect={handleAgencySelectChange}
                            dataKey="id"
                            textField="agencyName"
                        />
                    </div>
                    {selectedAgency ? (
                        <div>
                            {titlesAreLoading ? (
                                <>Loading <Loader type="converging-spinner"/></>
                            ) : (
                                <DropDown
                                    size="medium"
                                    label="Title"
                                    value={selectedTitle}
                                    listItems={agencyTitles}
                                    onSelect={handleTitleSelectChange}
                                    dataKey="id"
                                    textField="titleName"
                                    idName="titleNumber"
                                />
                            )}
                        </div>
                    ) : null }
                    {selectedTitle ? (
                        <div>
                            {chaptersAreLoading ? (
                                <>Loading <Loader type="converging-spinner"/></>
                            ) : (
                                <DropDown
                                    size="medium"
                                    label="Chapter"
                                    value={selectedChapter}
                                    listItems={titleChapters.filter((chapter) => chapter.chapterNumber !== null)}
                                    onSelect={handleChapterSelectChange}
                                    dataKey="id"
                                    textField="chapterName"
                                    idName="chapterNumber"
                                />
                            )}
                        </div>
                    ) : null}
                </div>
                {selectedChapter ? (
                    <>
                        {chapterHistoryIsLoading ? (
                            <>Loading <Loader type="converging-spinner"/></>
                        ) : (
                            <>
                                <div className={styles.horizontalDivider}></div>
                                <div className={styles.wrapper}>
                                    <ChapterHistoryForm chapter={selectedChapter} reloadChapterHistory={reloadChapterHistory} />
                                </div>
                                <div className={styles.horizontalDivider}></div>
                                <div className={styles.wrapper}>
                                    <ChapterHistoryTable chapter={selectedChapter} chapterHistory={chapterHistory} reloadChapterHistory={reloadChapterHistory}/>
                                </div>
                            </>
                        )}
                    </>
                ) : null}
            </div>
        );
    }

    return (
        <PrivatePageLayout>
          {renderChapterHistoryManagement()}
        </PrivatePageLayout>
      )
}

export default ChapterHistoryManagement;